import React, { useState } from 'react';

import FormControl from 'react-bootstrap/es/FormControl';
import { FormGroup } from 'react-bootstrap';
import styled from 'styled-components';
import { AxiosError } from 'axios';

import Modal from '../utils/ModalComponet';
import * as Service from '../../services/ActivitiesService';

import { TagForm } from './TagForm';

const StyledFormWrapper = styled.div`
  display: flex;

  .form-group {
    margin-right: 20px;
  }

  button {
    margin-left: 20px;
  }
`;

const initialForm = {
  name: '',
  type: '',
};

interface NewTagFormProps {
  isOpen: boolean;
  closeModal: () => void;
}

const NewTagForm = ({ isOpen, closeModal }: NewTagFormProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const [newTag, setNewTag] = useState(initialForm);

  const onTagCreate = async tag => {
    try {
      setIsLoading(true);
      await Service.updateTag(tag);
      setNewTag(initialForm);
      closeModal();
    } catch (e) {
      console.error(e);
      const error = e as AxiosError;
      alert(
        `Error code: ${error?.response?.status} \nError message: ${error?.response?.data}`
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      open={isOpen}
      closeModal={closeModal}
      cancel={closeModal}
      action={() => onTagCreate(newTag)}
      actionButtonText='Create'
      disabled={!newTag.name || !newTag.type || isLoading}
    >
      <h4>New Tag Form</h4>
      <StyledFormWrapper>
        <FormGroup>
          <FormControl
            type='text'
            placeholder='Name'
            onChange={event =>
              setNewTag({ ...newTag, name: event.target.value })
            }
            value={newTag.name}
          />
        </FormGroup>
        <TagForm
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          changeType={(_, type) => setNewTag({ ...newTag, type })}
          tag={newTag}
        />
      </StyledFormWrapper>
    </Modal>
  );
};

export default NewTagForm;
